import { FC, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import { DEVICE_TYPE } from "../../../utils/constants";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import "./EmailUsPopUp.scss";
import useCmsPageVariables from "../../../hooks/useCmsPageVariables";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

interface Props {
  open: boolean;
  handleOpen: Function;
}

const EmailUsPopUp: FC<Props> = ({ open, handleOpen }) => {
  const { t } = useAppTranslation("common");
  const deviceType = useDeviceDetection();
  const cmsEmailData = useCmsPageVariables("email-us");
  const handleClosePopup = useCallback(() => {
    handleOpen(false);
  }, [handleOpen]);

  const renderSteps = () => {
    if (deviceType === DEVICE_TYPE.WEB) {
      return (
        <Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            {t("emailUs.title") || "EMAIL US"}
          </Typography>
          <Typography sx={{ marginBottom: ".3125rem" }}>
            {t("emailUs.subtitle") || cmsEmailData?.attributes.title}
          </Typography>
          <Typography sx={{ color: "#0000FF" }}>
            {t("emailUs.contactEmail", {
              contactEmail: cmsEmailData?.attributes.text,
            }) || cmsEmailData?.attributes.text}
          </Typography>
        </Box>
      );
    } else {
      return (
        <Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            {t("emailUs.title") || "EMAIL US"}
          </Typography>
          <Typography sx={{ marginBottom: ".3125rem" }}>
            {t("emailUs.subtitle") || cmsEmailData?.attributes.title}
          </Typography>
          <Typography>
            {/* <a href={`mailto:${cmsEmailData?.attributes.text}?subject=Inquiry`}>
              {cmsEmailData?.attributes.text}
            </a> */}
            <a
              href={`mailto:${cmsEmailData?.attributes.text}?subject=Service%20Platform%20Inquiry`}
            >
              {t("emailUs.contactEmail", {
                contactEmail: cmsEmailData?.attributes.text,
              }) || cmsEmailData?.attributes.text}
            </a>
          </Typography>
        </Box>
      );
    }
  };
  return (
    <CustomPopup
      open={open}
      handleOpen={handleClosePopup}
      btnLabel={t("emailUs.close")}
      className="add-emailus-popup"
      btnStartIcon={<CloseIcon sx={{ fontSize: "1rem" }} />}
    >
      <Box
        className="add-emailus-popup-content"
        sx={{ margin: ".625rem", textAlign: "center", padding: ".625rem" }}
      >
        {renderSteps()}
      </Box>
    </CustomPopup>
  );
};
export default EmailUsPopUp;
